module.exports = __webpack_public_path__ + "img/13.9526d7ad.jpg";